import React from 'react';
import { CartesianGrid, Line, LineChart, ReferenceDot, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import type { RetentionPoint } from '../../utils/retention';
import { CHART } from '../../utils/theme';
import { fmtPct } from '../../utils/format';
import { ChartTooltip, LegendItem } from '../ui/ChartTooltip';
export function RetentionTrendChart({
  points,
  selectedBase,
  entityLabel
}: {
  points: RetentionPoint[];
  selectedBase: number;
  entityLabel: string;
}) {
  const selected = points.find(p => p.base === selectedBase);
  const axis = {
    tick: {
      fontSize: 11,
      fill: CHART.axis
    },
    axisLine: false,
    tickLine: false
  } as const;
  return <div data-id="element-489" data-mp="214mtrcrznk2w">
      <div className="mb-3 flex flex-wrap gap-x-4 gap-y-1" data-id="element-490" data-mp="1wc21wgsn7h20">
        <LegendItem color={CHART.navy} label={entityLabel} line data-id="element-491" data-mp="1wain6ummxe2c" />
        <LegendItem color={CHART.accent} label="Network" line dashed data-id="element-492" data-mp="18lpm6jr5og0v" />
        <LegendItem color={CHART.accent} label="Selected cohort" data-id="element-493" data-mp="13ned4b8oq9jp" />
      </div>
      <div className="h-[280px]" data-id="element-494" data-mp="13lbp1wr3eqhm">
        <ResponsiveContainer width="100%" height="100%" data-id="element-495" data-mp="2n5llszevki6l">
          <LineChart data={points} margin={{
          top: 10,
          right: 16,
          left: 0,
          bottom: 0
        }} data-id="element-496" data-mp="2n521jc1r5hpe">
            <CartesianGrid vertical={false} stroke={CHART.grid} data-id="element-497" data-mp="2s2u36xs78i6s" />
            <XAxis dataKey="label" {...axis} axisLine={{
            stroke: CHART.grid
          }} interval={0} data-id="element-498" data-mp="2wuvccau2lssl" />
            <YAxis tickFormatter={(v: number) => fmtPct(v, 0)} width={44} {...axis} domain={[0, 'auto']} data-id="element-499" data-mp="31uq4ehpl0of8" />
            <Tooltip content={<ChartTooltip formatter={v => fmtPct(v)} data-id="element-501" data-mp="247rbmi20g0mm" />} data-id="element-500" data-mp="2479ab70hqw7u" />
            <Line type="monotone" dataKey="scope" name={entityLabel} stroke={CHART.navy} strokeWidth={2.25} dot={{
            r: 3,
            fill: CHART.navy
          }} connectNulls isAnimationActive={false} data-id="element-502" data-mp="295aopemz27cz" />
            <Line type="monotone" dataKey="network" name="Network" stroke={CHART.accent} strokeWidth={2} strokeDasharray="5 4" dot={false} connectNulls isAnimationActive={false} data-id="element-503" data-mp="2i68x094g111d" />
            {selected && selected.scope !== null && <ReferenceDot x={selected.label} y={selected.scope} r={6} fill={CHART.accent} stroke="#fff" strokeWidth={2} data-id="element-504" data-mp="3tkuu8vw423nu" />}
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>;
}